module.exports = __webpack_public_path__ + "img/capa2.82645717.webp";